<google-map height="100%" width="100%" [options]="mapOptions" (mapInitialized)="onMapReady()">
  <map-marker *ngIf="markerAddress" [position]="markerAddress" [options]="markerOptions"></map-marker>
</google-map>
